import { render, staticRenderFns } from "./approval-box.vue?vue&type=template&id=14f6f56e&"
import script from "./approval-box.vue?vue&type=script&lang=js&"
export * from "./approval-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports